module.exports = __webpack_public_path__ + "img/qostanay3.355543b1.jpg";